import { Button, CircularProgress } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components/macro';
import Tooltip from '@material-ui/core/Tooltip';

const SLayout = styled.div`
    margin-right: ${(props) => (props.showMargin ? '30px' : 0)};
    display: inline-block;
    width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
`;

const SDummy = styled.span`
    width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
`;

const SLoadingLayout = styled.div`
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

// size can be 'small', 'medium', or 'large'
// embed icon with startIcon = <Icon />, endIcon = <Icon />

const CustomButton = ({
    children,
    type = 'action',
    variant = 'contained',
    size = 'small',
    color = 'primary',
    startIcon,
    showMargin = false,
    style = {},
    tooltip = '',
    showToolTipInDisabledOnly = false,
    disableOnPermission = false,
    disabled = false,
    allowAction = true,
    fullWidth,
    loading = false,
    buttonType = 'button',
    ...rest
}) => {
    const getDisableStatus = () => {
        if (disableOnPermission) {
            return true;
        }

        if (loading) {
            return true;
        }

        if (disabled) {
            return true;
        }

        if (allowAction === false) {
            return true;
        }

        return false;
    };

    const extraProps = {
        color,
        variant,
        size,
    };

    if (type === 'cancel') {
        delete extraProps.color;
    }

    if (startIcon) {
        extraProps.startIcon = startIcon;
    }

    let Wrapper = SDummy;
    const tooltipProps = {};

    if (tooltip) {
        if (!showToolTipInDisabledOnly || (showToolTipInDisabledOnly && disabled)) {
            Wrapper = Tooltip;
            tooltipProps.title = tooltip;
            tooltipProps.placement = 'top-start';
        }
    }

    return (
        <Wrapper fullWidth={fullWidth} {...tooltipProps}>
            <SLayout fullWidth={fullWidth} showMargin={showMargin}>
                <div style={{ position: 'relative' }}>
                    <Button
                        type={buttonType}
                        fullWidth={fullWidth}
                        size="small"
                        disabled={getDisableStatus()}
                        style={{ textTransform: 'none', ...style }}
                        {...extraProps}
                        {...rest}
                    >
                        {children}
                    </Button>
                    {loading && (
                        <SLoadingLayout>
                            <CircularProgress size={16} />
                        </SLoadingLayout>
                    )}
                </div>
            </SLayout>
        </Wrapper>
    );
};

export default CustomButton;
